module.exports = __webpack_public_path__ + "img/pay.767437bd.png";